import { finance } from "../data";
/**
 * @param {Phaser.Scene} scene
 * @param {Phaser.Physics.Arcade.Sprite} character
 */
export const jump = (scene, readyToJump, clickable, character, scaleX) => {
  if (readyToJump && clickable) {
    if (!finance.skinned) {
      scene.character.setTexture("jump0");
      scene.sound.play("jumpSound");
      character.stop("run");
      character.play("jump");
      character.setVelocityY(-1100 * scaleX);
      character.setGravityY(3000 * scaleX);
    } else {
      scene.character.setTexture("skinnedJump0");
      scene.sound.play("jumpSound");
      character.stop("skinnedRun");
      character.play("skinnedJump");
      character.setVelocityY(-1100 * scaleX);
      character.setGravityY(3000 * scaleX);
    }
  }
};

/** @param {Phaser.Scene} scene*/
/** @param {Phaser.Physics.Arcade.Sprite} character*/
export const slide = (readyToJump, clickable, character) => {
  if (readyToJump && clickable) {
    if (!finance.skinned) {
      character.stop("run");
      character.play("slide");
    } else {
      character.stop("skinnedRun");
      character.play("skinnedSlide");
    }
  }
};
